import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function LaborCost(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='labor-cost-glance-body'
                cssHeadingClass='labor-cost-glance-heading'
                cssIconClass='icons8-construction-worker'
                Heading={t('LaborCost')}
                DataPoint1={props.DP1}
                DataPoint3={'<div>' + props.DP2 + ' ' + t('Labor') + '</br>' + props.DP3 + ' ' + t('Sales') + '</div>'}
            ></BaseDataGlance>
        </>
    );
}